var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table_class" },
    [
      _c(
        "el-table",
        {
          ref: "tableRef",
          staticStyle: { width: "100%" },
          attrs: {
            "header-cell-style": { background: "#f8fafc", color: "#6b7589" },
            "row-class-name": _vm.rowClassName,
            "max-height": 500,
            border: "",
            data: _vm.tableData,
          },
        },
        _vm._l(_vm.tableHeaderList, function (item, index) {
          return _c("el-table-column", {
            key: index,
            attrs: {
              label: item.label,
              "min-width": item.width,
              prop: item.prop,
              "show-overflow-tooltip": true,
              align: "center",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      item.prop === "currentTicketCount"
                        ? _c("div", [
                            _c(
                              "span",
                              { style: _vm.getHubCodeStyle(scope.$index) },
                              [_vm._v(_vm._s(scope.row[item.prop] || "--"))]
                            ),
                          ])
                        : item.prop === "hubLevel" && scope.row.hubLevel
                        ? _c("div", [
                            _c(
                              "span",
                              {
                                staticClass: "tag_class",
                                staticStyle: { background: "#f2f4f7" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.hubLVFn(scope.row.hubLevel)) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        : item.prop === "stockTurnoverDays" &&
                          scope.row.stockTurnoverDays
                        ? _c("div", [
                            _c(
                              "span",
                              {
                                staticClass: "tag_class",
                                style:
                                  scope.$index === 0
                                    ? {}
                                    : {
                                        background:
                                          scope.row.stockTurnoverDays <= 1
                                            ? "#ecfdf3"
                                            : scope.row.stockTurnoverDays <= 2
                                            ? "#fdf8ec"
                                            : scope.row.stockTurnoverDays <= 3
                                            ? "#fffaeb"
                                            : "#fef3f2",
                                        color:
                                          scope.row.stockTurnoverDays <= 1
                                            ? "#079455"
                                            : scope.row.stockTurnoverDays <= 2
                                            ? "#dcca03"
                                            : scope.row.stockTurnoverDays <= 3
                                            ? "#df771a"
                                            : "#d92d20",
                                      },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.stockTurnoverDays) +
                                    _vm._s(_vm.$t("basicData.NumberOfDays")) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        : item.prop === "avgInventoryHours" &&
                          scope.row.avgInventoryHours
                        ? _c("div", [
                            _c(
                              "span",
                              {
                                staticClass: "tag_class",
                                style:
                                  scope.$index === 0
                                    ? {}
                                    : {
                                        background:
                                          scope.row.avgInventoryHours <= 24
                                            ? "#ecfdf3"
                                            : scope.row.avgInventoryHours <= 36
                                            ? "#fdf8ec"
                                            : scope.row.avgInventoryHours <= 48
                                            ? "#fffaeb"
                                            : "#fef3f2",
                                        color:
                                          scope.row.avgInventoryHours <= 24
                                            ? "#079455"
                                            : scope.row.avgInventoryHours <= 36
                                            ? "#dcca03"
                                            : scope.row.avgInventoryHours <= 48
                                            ? "#df771a"
                                            : "#d92d20",
                                      },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.avgInventoryHours) +
                                    "h "
                                ),
                              ]
                            ),
                          ])
                        : item.prop === "inventoryAgingRate" &&
                          scope.row.inventoryAgingRate
                        ? _c("div", [
                            _c(
                              "span",
                              {
                                staticClass: "tag_class",
                                style:
                                  scope.$index === 0
                                    ? {}
                                    : {
                                        background:
                                          scope.row.inventoryAgingRate <= 5
                                            ? "#ecfdf3"
                                            : scope.row.inventoryAgingRate <= 10
                                            ? "#fdf8ec"
                                            : scope.row.inventoryAgingRate <= 20
                                            ? "#fffaeb"
                                            : "#fef3f2",
                                        color:
                                          scope.row.inventoryAgingRate <= 5
                                            ? "#079455"
                                            : scope.row.inventoryAgingRate <= 10
                                            ? "#dcca03"
                                            : scope.row.inventoryAgingRate <= 20
                                            ? "#df771a"
                                            : "#d92d20",
                                      },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(scope.row.inventoryAgingRate) +
                                    "% "
                                ),
                              ]
                            ),
                          ])
                        : item.prop === "netIncreaseTicketCount" &&
                          scope.row.netIncreaseTicketCount != null
                        ? _c("div", [
                            _c(
                              "span",
                              {
                                staticClass: "tag_class",
                                style:
                                  scope.$index === 0
                                    ? {}
                                    : {
                                        background:
                                          scope.row.netIncreaseTicketCount < 0
                                            ? "#ecfdf3"
                                            : scope.row
                                                .netIncreaseTicketCount === 0
                                            ? "#f3f1ee"
                                            : scope.row.netIncreaseTicketCount >
                                              0
                                            ? "#fef3f2"
                                            : "",
                                        color:
                                          scope.row.netIncreaseTicketCount < 0
                                            ? "#079455"
                                            : scope.row
                                                .netIncreaseTicketCount == 0
                                            ? "#989898"
                                            : scope.row.netIncreaseTicketCount >
                                              0
                                            ? "#d92d20"
                                            : "",
                                      },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.netIncreaseTicketCount >= 0
                                        ? "+"
                                        : ""
                                    ) +
                                    _vm._s(scope.row.netIncreaseTicketCount) +
                                    " "
                                ),
                              ]
                            ),
                          ])
                        : _c("div", [
                            _vm._v(
                              " " + _vm._s(scope.row[item.prop] || "--") + " "
                            ),
                          ]),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }